import { LegalShell } from "../components/LegalShell";
import { useSeo } from "../lib/useSeo";

const PrivacyPolicy = () => {
    useSeo({
        title: "Privacy Policy | Shillong Morning Teer Result Today",
        description: "Read how Shillong Morning Teer Result Today collects, stores and protects your personal data. Our privacy policy explains cookies, analytics and third-party sharing.",
        keywords: "shillong morning teer privacy policy, morningteerkhela privacy",
        path: "/privacy-policy",
        breadcrumbs: [
            { name: "Home", path: "/" },
            { name: "Privacy Policy", path: "/privacy-policy" },
        ],
    });

    return (
        <LegalShell title="Privacy Policy" breadcrumb="Privacy Policy" subtitle="How we handle your data.">
            <p>
                This Privacy Policy explains how <strong>Shillong Morning Teer Result Today</strong>{" "}
                (“we”, “our”, “us”) collects, uses and safeguards information when you visit our
                website. By using the site you agree to the practices described below.
            </p>

            <h2>Information We Collect</h2>
            <p>
                We collect only the minimum information necessary to run the website and improve your
                experience:
            </p>
            <ul>
                <li><strong>Log data</strong> — IP address, browser type, referring URL and pages visited (via anonymised analytics).</li>
                <li><strong>Cookies</strong> — small text files that remember your preferences and allow admin authentication.</li>
                <li><strong>Contact information</strong> — only when you voluntarily send a message via the Contact page.</li>
            </ul>

            <h2>How We Use Information</h2>
            <ul>
                <li>To display Teer results and personalise the timezone (India Standard Time).</li>
                <li>To identify authenticated admins for publishing content.</li>
                <li>To detect abuse, prevent fraud and monitor uptime.</li>
                <li>To improve our design and page speed based on aggregated analytics.</li>
            </ul>

            <h2>Cookies</h2>
            <p>
                We use a strictly necessary authentication cookie (<code>access_token</code>) for the
                admin panel only, and privacy-respecting analytics cookies for measuring traffic. You
                can disable cookies in your browser at any time; the public results pages will
                continue to work normally.
            </p>

            <h2>Third-Party Services</h2>
            <p>
                We rely on a small number of privacy-conscious vendors: Google Fonts (for typography),
                PostHog (privacy-focused product analytics), and cloud hosting. These providers
                receive only the minimum data required to operate.
            </p>

            <h2>Data Retention</h2>
            <p>
                Analytics data is retained in an aggregated, non-identifying form for up to 12 months.
                Contact form messages are deleted 90 days after they are resolved.
            </p>

            <h2>Your Rights</h2>
            <p>
                You may request access, correction or deletion of any personal information you have
                shared with us by emailing <a href="mailto:support@shillongmorningteerresulttoday.com">support@shillongmorningteerresulttoday.com</a>.
            </p>

            <h2>Children</h2>
            <p>
                This website is not directed at children under 18 years of age. We do not knowingly
                collect information from minors.
            </p>

            <h2>Changes to this Policy</h2>
            <p>
                We may update this Privacy Policy occasionally. Material changes will be highlighted
                on the homepage for at least 14 days before taking effect.
            </p>

            <h2>Contact</h2>
            <p>
                For privacy-related enquiries write to <a href="mailto:support@shillongmorningteerresulttoday.com">support@shillongmorningteerresulttoday.com</a>.
            </p>
        </LegalShell>
    );
};

export default PrivacyPolicy;
